module.exports = __webpack_public_path__ + "img/Recruiting Support.bb5685ff.png";